import { orgSearch } from '../helpers';
import { api } from './api';

export function getUserProgramsAPI(userID, callback) {
  const data = {
    user_id: userID,
  };

  // Array to store program results
  const programsArray = [];

  api.ibldmprograms.getUserPrograms(data, function (userPrograms) {
    // Counter to keep track of completed requests
    let counter = 0;
    if (userPrograms && !userPrograms.length) {
      callback([]);
    }
    userPrograms.forEach((program, i) => {
      const program_id = program.program_id;
      const searchData =
        '?detail_indice={"_index":"ibl-dm.public.dl_catalog_app_program"}&detail_scope={"program_id":"' +
        program_id +
        '"}';

      orgSearch(searchData, function (programData) {
        const programResult = programData.results[0]._source;
        programsArray.push(programResult);

        // Check if all requests are completed before invoking the callback
        counter++;
        if (counter === userPrograms.length) {
          // All requests completed, invoke callback with the array
          callback(programsArray);
        }
      });
    });
  });
}
